<div class="mat-optgroup-title">
  <span>{{ title() }}</span>
  @if (action()) {
    <span> - </span>
  }
  @if (!loading()) {
    <a
      [class.hidden]="!action()"
      (click)="onClose()"
      [routerLink]="actionLink()"
      [queryParams]="actionQueryParams()"
      >{{ action() }}</a
      >
    } @else {
      <semeris-loader [loading]="loading()" [inline]="false" [diameter]="14"></semeris-loader>
    }
  </div>

